export const getMyOrigin = () => {
  if (process.env.NODE_ENV === 'development') {
    return process.env.GATSBY_DEV_ORIGIN || 'http://localhost:8888';
  }
  return typeof window !== 'undefined' ? window.location.origin : '';
};
